/* eslint-disable */
// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit";

const initialUser = () => {
  const item = window.localStorage.getItem("userData");
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {};
};

export const authSlice = createSlice({
  name: "authentication",
  initialState: {
    user: initialUser(),
    fullUser: {},
    notiCount: 0,
    lang_code: "en",
    configuration: [],
    configuration1: [],
    configuration2: [],
    configuration3: [],
    client: {
      step: 1,
    },
    therapist: {
      step: 1,
    },
    student: {
      step: 1,
    },
    counselor: {
      step: 1,
    },
    emotion: [],
    activeUser: [],
  },
  reducers: {
    handleLogin: (state, action) => {
      state.user = action.payload;

      //state[config.storageTokenKeyName] =
      // action.payload[config.storageTokenKeyName];

      localStorage.setItem("userData", JSON.stringify(action.payload));
      // localStorage.setItem(
      //   config.storageTokenKeyName,
      //   JSON.stringify(action.payload.accessToken)
      // );
    },
    handleLoginRaw: (state, action) => {
      state.fullUser = action.payload;
      localStorage.removeItem("fullUserData");
    },
    handleLogout: (state) => {
      state.userData = {};
      state.user = {};
      state.fullUser = {};
      state.notiCount = 0;
      state.configuration = [];
      state.configuration1 = [];
      state.configuration2 = [];
      state.client = {
        step: 1,
      };
      state.therapist = {
        step: 1,
      };
      state.student = {
        step: 1,
      };
      state.counselor = {
        step: 1,
      };
      state.emotion = [];
      state.activeUser = [];

      // state[config.storageRefreshTokenKeyName] = null;
      // ** Remove user, accessToken & refreshToken from localStorage
      for (const key of [
        "userData",
        "fullUserData",
        "newSignup",
        "accessToken",
        "refreshToken",
        "token",
      ])
        localStorage.removeItem(key);
      // localStorage.removeItem(config.storageTokenKeyName);
      // localStorage.removeItem(config.storageRefreshTokenKeyName);
    },

    handleUserDetails: (state, action) => {
      state.user.fullName = action?.payload?.fullname;
      state.user.avatar = action?.payload?.avatar;
    },
    handleUserLanguage: (state, action) => {
      state.user.language = action?.payload?.language;
    },
    handleAuth: (state, action) => {
      state.user.accessToken = action?.payload?.accessToken;
      state.user.refreshToken = action?.payload?.refreshToken;
    },
    handleNotiCount: (state, action) => {
      state.notiCount = action.payload;
    },
    addNotiCount: (state) => {
      state.notiCount += 1;
    },
    resetNotiCount: (state) => {
      state.notiCount = 0;
    },
    handleConfiguration: (state, action) => {
      state.configuration = action.payload;
    },
    handleConfiguration1: (state, action) => {
      state.configuration1 = action.payload;
    },
    handleConfiguration3: (state, action) => {
      state.configuration3 = action.payload;
    },
    handleConfigurationHome: (state, action) => {
      state.configuration2 = action.payload;
    },
    handleClientData: (state, action) => {
      state.client = {
        ...state.client,
        ...action.payload, // merges new keys/values
      };
    },
    handleClientClear: (state, action) => {
      state.client = action.payload;
    },
    handleStudentData: (state, action) => {
      state.student = {
        ...state.student,
        ...action.payload, // merges new keys/values
      };
    },
    handleStudentClear: (state, action) => {
      state.student = action.payload;
    },
    handleTherapistData: (state, action) => {
      state.therapist = {
        ...state.therapist,
        ...action.payload, // merges new keys/values
      };
    },
    handleTherapistClear: (state, action) => {
      state.therapist = action.payload;
    },
    handleCounselorData: (state, action) => {
      state.counselor = {
        ...state.counselor,
        ...action.payload, // merges new keys/values
      };
    },
    handleCounselorClear: (state, action) => {
      state.counselor = action.payload;
    },
    handleEmotion: (state, action) => {
      state.emotion = action.payload;
    },
    handleActiveUser: (state, action) => {
      state.activeUser = action?.payload;
    },
    handleLanguage: (state, action) => {
      state.lang_code = action?.payload;
    },
    handleNotificationSetting: (state, action) => {
      state.user = { ...state.user, notification: action.payload };
      try {
        const stored = window.localStorage.getItem("userData");
        if (stored) {
          const parsed = JSON.parse(stored);
          parsed.notification = action.payload;
          window.localStorage.setItem("userData", JSON.stringify(parsed));
        }
      } catch (e) {
        console.error("Failed to persist notification preference", e);
      }
    },
  },
});

export const {
  handleLogin,
  handleLogout,
  handleUserDetails,
  handleUserLanguage,
  handleAuth,
  addNotiCount,
  resetNotiCount,
  handleNotiCount,
  handleConfiguration,
  handleConfiguration1,
  handleConfiguration3,
  handleConfigurationHome,
  handleClientData,
  handleClientClear,
  handleStudentData,
  handleStudentClear,
  handleTherapistData,
  handleTherapistClear,
  handleCounselorData,
  handleCounselorClear,
  handleEmotion,
  handleActiveUser,
  handleLanguage,
  handleNotificationSetting,
  handleLoginRaw,
} = authSlice.actions;

export default authSlice.reducer;
